import EventBox from '../EventBox';
import { formatTime, parseTime } from '../../utils/timeUtils';
import { SLOT_HEIGHT, DAY_HOURS, DAY_HEIGHT } from './useDiary';

const buildEvents = (entries, selectedDate) => {
  const dayStart = new Date(selectedDate || new Date());
  dayStart.setHours(0, 0, 0, 0);
  const events = [];

  (entries || []).forEach(entry => {
    if (entry.entry_type === 'appuntamento' && entry.start_time) {
      const s = new Date(entry.start_time);
      const e = entry.end_time ? new Date(entry.end_time) : new Date(s.getTime() + 30 * 60000);
      events.push({ id: `e_${entry.id}`, start: s, end: e, type: 'entry', data: entry });
    }
    if (entry.notes && entry.notes.length) {
      entry.notes.forEach((n, ni) => {
        const startParsed = parseTime(n.start_orario) || parseTime(n.orario);
        if (!startParsed) return;
        const s = new Date(dayStart);
        s.setHours(startParsed.hh, startParsed.mm, 0, 0);
        const endParsed = parseTime(n.end_orario);
        const e = endParsed
          ? (() => { const ed = new Date(dayStart); ed.setHours(endParsed.hh, endParsed.mm, 0, 0); return ed; })()
          : new Date(s.getTime() + 30 * 60000);
        events.push({ id: `n_${entry.id}_${ni}`, start: s, end: e, type: 'note', data: n, parent: entry });
      });
    }
  });

  events.sort((a, b) => a.start - b.start || a.end - b.end);
  return events;
};

const layoutEvents = (events) => {
  const assigned = [];
  const columns = [];
  events.forEach(ev => {
    let placed = false;
    for (let c = 0; c < columns.length; c++) {
      if (ev.start >= columns[c][columns[c].length - 1].end) {
        columns[c].push(ev);
        assigned.push({ ev, col: c });
        placed = true;
        break;
      }
    }
    if (!placed) { columns.push([ev]); assigned.push({ ev, col: columns.length - 1 }); }
  });
  return assigned.map(a => {
    const overlaps = assigned.filter(x => !(x.ev.end <= a.ev.start || x.ev.start >= a.ev.end));
    const minCol = Math.min(...overlaps.map(x => x.col));
    const colsInGroup = Math.max(...overlaps.map(x => x.col)) - minCol + 1;
    return { ev: a.ev, colIndex: a.col - minCol, colsInGroup };
  });
};

const DiaryTimeGrid = ({ entries, selectedDate, containerRef, onEmptyDoubleClick, onEventClick }) => {
  const events = buildEvents(entries, selectedDate);
  const rendered = layoutEvents(events);

  return (
    <div style={{ display: 'flex', gap: 16 }}>
      <div style={{ width: 90 }}>
        {[...Array(DAY_HOURS).keys()].map(h => (
          <div key={h} style={{ height: SLOT_HEIGHT, borderBottom: '1px solid #eee', padding: 8, boxSizing: 'border-box', display: 'flex', alignItems: 'center' }}>
            {String(h).padStart(2, '0')}:00
          </div>
        ))}
      </div>

      <div style={{ flex: 1, position: 'relative' }}>
        <div ref={containerRef} onDoubleClick={onEmptyDoubleClick} style={{ position: 'relative', height: DAY_HEIGHT, border: '1px solid #f0f0f0', background: '#fff' }}>
          {events.length === 0
            ? <div style={{ padding: 12 }}>Nessuna registrazione per questa data.</div>
            : rendered.map(({ ev, colIndex, colsInGroup }) => {
                const startMin = ev.start.getHours() * 60 + ev.start.getMinutes();
                const endMin   = ev.end.getHours()   * 60 + ev.end.getMinutes();
                const top    = startMin * (SLOT_HEIGHT / 60);
                const height = Math.max(20, (endMin - startMin) * (SLOT_HEIGHT / 60)) || 20;
                return (
                  <div
                    key={ev.id}
                    onClick={e => { e.stopPropagation(); onEventClick(ev); }}
                    style={{
                      position: 'absolute',
                      top,
                      left: `${(colIndex / colsInGroup) * 100}%`,
                      width: `calc(${(1 / colsInGroup) * 100}% - 6px)`,
                      height,
                      marginLeft: 6,
                      padding: 6,
                      boxSizing: 'border-box',
                      border: '1px solid #ddd',
                      background: ev.type === 'entry' ? '#e8f4ff' : '#fff6e6',
                      overflow: 'hidden',
                      borderRadius: 4,
                      cursor: 'pointer',
                    }}
                  >
                    <EventBox ev={ev} onClick={e => { e.stopPropagation(); onEventClick(ev); }} formatTime={formatTime} />
                  </div>
                );
              })
          }
        </div>
      </div>
    </div>
  );
};

export default DiaryTimeGrid;
